import { useContext } from 'react';

import { Descriptions, Drawer, Flex } from 'antd';

import { useGetSingleReportBatchQualityStats } from '@/api/batch_process';
import { PageContext } from '@/providers/PageContextProvider';

export default function ViewBatchProcessReportDrawer() {
	const { drawer, closeDrawer } = useContext(PageContext);

	const report_id = drawer?.data?.batch_id;

	const { data, isLoading, isFetching } = useGetSingleReportBatchQualityStats(
		report_id,
		drawer.isOpen && drawer.type === 'view-batch-process-report' && !!report_id,
	);

	const onClose = () => {
		closeDrawer();
	};

	const statsData = data?.data?.data;

	return (
		<Drawer
			open={drawer.isOpen && drawer.type === 'view-batch-process-report'}
			width={'450px'}
			onClose={onClose}
			title={
				<Flex vertical>
					<span>Batch process report </span>
					<span>{drawer?.data?.batch_id}</span>
				</Flex>
			}
			loading={isLoading || isFetching}
		>
			<Descriptions column={1} bordered size="small">
				{/* {drawer?.data?.batch_id && ( */}
				<Descriptions.Item label="📊 Total record count">
					{/* {drawer?.data?.batch_id} */}
					{/* {Math.floor(Math.random() * 1000)} */}
					{statsData?.total_records || 0}
				</Descriptions.Item>
				{/* )} */}
				{/* {drawer?.data?.batch_id && ( */}
				<Descriptions.Item label="⏱️ Total video hours">
					{/* {drawer?.data?.batch_id} */}
					{/* {Math.floor(Math.random() * 1000)} */}
					{statsData?.duration_hours ? statsData.duration_hours.toFixed(2) : 0}
				</Descriptions.Item>
				{/* )} */}
				{/* {drawer?.data?.batch_id && ( */}
				<Descriptions.Item label="❌ Download failed">
					{/* {drawer?.data?.batch_id} */}
					{/* {Math.floor(Math.random() * 1000)} */}
					{statsData?.download_failed || 0}
				</Descriptions.Item>
				<Descriptions.Item label="🚫 No transcription">
					{/* {drawer?.data?.batch_id} */}
					{/* {Math.floor(Math.random() * 100)} */}
					{statsData?.no_transcription || 0}
				</Descriptions.Item>
				{/* )} */}
				{/* {drawer?.data?.batch_id && ( */}
				<Descriptions.Item label="🌐 Not English">
					{/* {drawer?.data?.batch_id} */}
					{/* {Math.floor(Math.random() * 100)} */}
					{statsData?.not_english || 0}
				</Descriptions.Item>
				{/* )} */}
				{/* {drawer?.data?.batch_id && ( */}
				<Descriptions.Item label="⬇️ Low word count">
					{/* {drawer?.data?.batch_id} */}
					{/* {Math.floor(Math.random() * 100)} */}
					{statsData?.low_word_count || 0}
				</Descriptions.Item>
				{/* )} */}
				{/* {drawer?.data?.batch_id && ( */}
				<Descriptions.Item label="🔄 Repeating patterns">
					{/* {drawer?.data?.batch_id} */}
					{/* {Math.floor(Math.random() * 1000)} */}
					{statsData?.repeating_patterns || 0}
				</Descriptions.Item>
				{/* )} */}

				{/* {drawer?.data?.batch_id && ( */}
				<Descriptions.Item label="🔠 Excessive uppercase">
					{/* {drawer?.data?.batch_id} */}
					{/* {Math.floor(Math.random() * 10)} */}
					{statsData?.excessive_uppercase || 0}
				</Descriptions.Item>
				{/* )} */}
				{/* {drawer?.data?.batch_id && ( */}
				<Descriptions.Item label="🈲 Non-ASCII characters">
					{/* {drawer?.data?.batch_id} */}
					{/* {Math.floor(Math.random() * 100)} */}
					{statsData?.foreign_characters || 0}
				</Descriptions.Item>
				{/* )} */}

				{/* {drawer?.data?.batch_id && ( */}
				<Descriptions.Item label="✅ Final number passed">
					{/* {drawer?.data?.batch_id} */}
					{/* {Math.floor(Math.random() * 1000)} */}
					{statsData?.passed || 0}
				</Descriptions.Item>
				{/* )} */}

				{/* {drawer?.data?.batch_id && ( */}

				{/* )} */}
			</Descriptions>
		</Drawer>
	);
}
